import { useIngredientListContext } from "../useIngredientListContext";
import { AutoGrid } from "src/components/Grid/layout/AutoGrid";
import { useIsProductUxV2 } from "src/hooks/useIsProductUxV2";

const IngredientsGrid = () => {
    const isProductUxV2 = useIsProductUxV2();
    const {
        mrt_columns,
        ingredients,
        isRefetching,
        isReady,
        totalItems,
        menuItems,
        tableActions,
        gridKey,
        columnConfiguration,
        appSearch,
        pagination,
    } = useIngredientListContext();

    const isLoading = isReady === false || isRefetching === true;

    return (
        <AutoGrid
            appearance={isProductUxV2 ? "hub" : undefined}
            enableColumnsAction
            gridKey={gridKey}
            columns={mrt_columns}
            data={ingredients}
            isLoading={isLoading}
            totalItems={totalItems}
            searchParams={appSearch}
            menuItems={menuItems}
            tableActions={tableActions}
            columnsConfig={columnConfiguration}
            pagination={pagination}
        />
    );
};

export default IngredientsGrid;
